import { render, staticRenderFns } from "./StaffUpdate.vue?vue&type=template&id=0ba22310&scoped=true&"
import script from "./StaffUpdate.vue?vue&type=script&lang=js&"
export * from "./StaffUpdate.vue?vue&type=script&lang=js&"
import style0 from "./StaffUpdate.vue?vue&type=style&index=0&id=0ba22310&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba22310",
  null
  
)

export default component.exports